export class Detail 
{
    public ID:string = '';
    public UniversalID:string = '';

    public OrderID:string = '';
    public ItemID:string = '';
    public GroupID:string = '';

    public Icon:string = '';
    public ShowIcon:boolean = false;
    public Name:string = '';
    public ShortName:string = '';
    public Description:string = '';
    public Tags:Array<string> = new Array<string>();

    public Price:number = 0.0;
    public DefaultCount:number = 0;
    public MaxCount:number = 1;
    public CurrentCount:number = 0;
    public HasValue:boolean = true;

    public Number:number = 0;
    public Removed:boolean = false;
    public OutOfStock:boolean = false;
    public ProductCount:number = 0;

    public PriceString:string = '';
    public Type:number = -1;
    
    //public List<ProductRequestModel> Recipe { get; set; }

    public get PrintName()
    {
        if (this.MaxCount == 1 || this.CurrentCount == 1)
            return this.ShortName;
        else
            return `${this.CurrentCount}x ${this.ShortName}`;
    }
}
